import { FormControl, FormGroup } from '@angular/forms';
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {
  IClientForm,
  IClientFormResponseApi,
  IClientListResponseApi,
  IClientResponseApi,
  ICompanyPlansResponseApi,
  IDetailsEnterpriseResponseApi
} from '../interfaces/clients/client.interface';
import { IPerson, IPersonFormResponseApi } from '../interfaces/person/person.interface';


@Injectable({
  providedIn: 'root'
})
export class ClientsService {
  private readonly http = inject(HttpClient);

  formFilterList = new FormGroup({
    document: new FormControl(''),
    name: new FormControl(''),
    isHeadOffice: new FormControl(''),
    status: new FormControl(''),
    page: new FormControl(1),
    pageSize: new FormControl(5),
    sortBy: new FormControl(''),
    sortOrder: new FormControl(''),
  });

  listAll(payload: {
    pageSize: number;
    page: number;
    document?: string;
    name?: string;
    isHeadOffice?: string;
    status?: string;
    sortBy?: string;
    sortOrder?: string;
  }) {
    let params = new HttpParams()
      .set('page', payload.page)
      .set('pageSize', payload.pageSize);

    if (payload.status) {
      params = params.set('status', payload.status);
    }

    if (payload.document) {
      params = params.set('document', payload.document);
    }

    if (payload.name) {
      params = params.set('name', payload.name);
    }

    if (payload.isHeadOffice) {
      params = params.set('isHeadOffice', payload.isHeadOffice);
    }

    if (payload.sortBy) {
      params = params.set('sortBy', payload.sortBy);
    }

    if (payload.sortOrder) {
      params = params.set('sortOrder', payload.sortOrder);
    }

    return this.http.get<any>(
      `${environment.api}/client/all`, { params }
    );
  }

  export(payload: {
    document?: string;
    name?: string;
    isHeadOffice?: string;
    status?: string;
    sortBy?: string;
    sortOrder?: string;
  }) {
    let params = new HttpParams()

    if (payload.status) {
      params = params.set('status', payload.status);
    }

    if (payload.document) {
      params = params.set('document', payload.document);
    }

    if (payload.name) {
      params = params.set('name', payload.name);
    }

    if (payload.isHeadOffice) {
      params = params.set('isHeadOffice', payload.isHeadOffice);
    }

    if (payload.sortBy) {
      params = params.set('sortBy', payload.sortBy);
    }

    if (payload.sortOrder) {
      params = params.set('sortOrder', payload.sortOrder);
    }

    return this.http.get(
      `${environment.api}/client/all/export`,
      { params, responseType: 'blob' }
    );
  }

  headOfficeList(payload: {
    name?: string;
  }) {
    let params = new HttpParams();

    if (payload.name) {
      params = params.set('name', payload.name);
    }

    return this.http.get<IClientListResponseApi>(
      `${environment.api}/client/head-offices`, {
        params,
        headers: new HttpHeaders().set('x-skip-loading', 'true')
      }
    );
  }

  getById(id: string) {
    return this.http.get<IClientResponseApi>(
      `${environment.api}/client/${id}`
    );
  }

  getCompanyPlans(id: string) {
    return this.http.get<ICompanyPlansResponseApi>(
      `${environment.api}/client/company-plans/${id}`
    );
  }

  getDetailsEnterprise(id: string) {
    return this.http.get<IDetailsEnterpriseResponseApi>(
      `${environment.api}/client/details/${id}`
    );
  }

  register(body: IClientForm) {
   if (body.id) {
    return this.update(body);
   }
   else {
    return this.create(body);
   }
  }

  create(body: IClientForm) {
    return this.http.post<IClientFormResponseApi>(
      `${environment.api}/client/create`, body
    );
  }

  update(body: IClientForm) {
    return this.http.put<IClientFormResponseApi>(
      `${environment.api}/client/update/${body.id}`, body
    );
  }

  adjustData(body: IPerson) {
    return this.http.post<IPersonFormResponseApi>(`${environment.api}/client/adjust-data`, body);
  }
}
